import React from 'react';
import {Link} from "react-router-dom";
import {Slang} from "../../../helpers";

const SupplierMenu = () => {
    const menu1 = Slang('dashboard.menu.m1');
    return (
        <div id="dashboardSidebar" className="nav-collapse collapse ">
            <a className="nav-link dropdown-toggle"
               href="#supplierMenu" role="button"
               data-bs-toggle="collapse"
               aria-expanded="false"
               aria-controls="supplierMenu">{menu1('m12.title')}</a>

            <div id="supplierMenu" className="nav-collapse collapse ">
                <Link className="nav-link" to="/dashboard/company">{menu1('m12.u2.m121')}</Link>
                <Link className="nav-link" to="/dashboard/company">{menu1('m12.u2.m122')}</Link>
            </div>
        </div>
    );
};

export default SupplierMenu;